module.exports = __webpack_public_path__ + "img/2-Desecamiento de sedimientos.bb61293a.png";